import React from "react";
import { postRequest } from "./QuoteApiService";

export const getItemQuoteHistory = (rec) => {
  return new Promise((resolve, reject) => {
    try {
      // do an SDK, DB call or API endpoint axios call here and return the promise.
      postRequest('GetItemQuoteHistory/', rec)
      .then((res) => {
        console.log("getItemQuoteHistory > axios res=", res);
        //const persons = res.data;
        resolve(res.data);
      })
      .catch((err) => {
        console.log("getItemQuoteHistory > axios err=", err);
        reject("Error in getItemQuoteHistory axios!");
      });
    } catch (error) {
      console.error("in services > getItemQuoteHistory, Err===", error);
      //reject(SYSTEM_ERROR);
    }
  });
  
}
